// import AuthGuard from './auth-guard'
import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/Home'
import listing from "@/views/Listing/listing";
import invoice from "@/views/Listing/invoice";
import item from "@/views/Listing/item";
import quote from "@/views/Quote/quote";
import imageQuote from "@/views/Quote/imageQuote";
import checkPhoneAuth from "@/views/User/checkPhoneAuth";
import stripeChargeCheckout from "@/views/payments/stripeChargeCheckout";
import transactionStatus from "@/views/payments/transactionStatus";
import webBookingDeposit from "@/views/payments/quoteDepositBooking"
// import itemPage from  "@/views/Listing/item"
// import signin from '@/views/user/signin'
// import userProfile from "@/views/user/userProfile";


Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/webBookingDeposit/:publicListingId/:listingId/:quoteId',
      name: 'webBookingDeposit',
      component: webBookingDeposit,
      props: true
    },
    {
      path: '/transactionStatus/:transactionId',
      name: 'transactionStatus',
      component: transactionStatus,
      props: true
    },
    {
      path: '/checkSmsAuth/:publicListingId/:routeTo/:routeType/:orderId',
      name: 'checkPhoneAuth',
      component: checkPhoneAuth,
      props: true
    },
    {
      path: '/stripeCheckout/:uid/:publicListingId/:invoiceId',
      name: 'stripeCheckout',
      component: stripeChargeCheckout,
      props: true
    },
    {
      path: '/imageQuote/:publicListingId/:listingId',
      name: 'imgQuote',
      component: imageQuote,
      props: true
    },
    {
      path: '/quotes/:publicListingId/:listingId/:quoteId',
      name: 'quote',
      component: quote,
      props: true
    },
    {
      path: '/:publicListingId/:listingId',
      name: 'listing',
      component: listing,
      props: true
    },
    {
      path: '/:publicListingId/:listingId/item/:itemId',
      name: 'item',
      component: item,
      props: true
    },
    {
      path: '/:publicListingId/invoice/:invoiceId',
      name: 'invoice',
      component: invoice,
      props: true
    },
    // {
    //   path: '/:listingsId',
    //   name: 'listings',
    //   component: listings,
    //   props: true
    // }
    // {
    //   path: '/signin',
    //   name: 'signin',
    //   component: signin
    // },
    // {
    //   path: '/editProfile',
    //   name: 'userProfile',
    //   component: userProfile,
    //   beforeEnter: AuthGuard
    // }
  ],
  mode: 'history'
})
